import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

i18n
	.use(XHR)
	.use(initReactI18next) // bind react-i18next to the instance
	.init(
		{
			backend: {
				loadPath: '/locales/{{lng}}/translation.json'
			},
			// Languages without their own UI translation fall back to English,
			// except Finnish variants (fi_selko), whose readers are better
			// served by the Finnish UI.
			fallbackLng: code =>
				code && code.toLowerCase().startsWith('fi') ? ['fi'] : ['en'],
			// debug: true,
			// The explicit 'fi' default matters: with lng undefined, i18next
			// would boot in the fallback language (English).
			lng: window.localStorage.getItem('i18nextLng')?.toLowerCase() || 'fi',
			interpolation: {
				escapeValue: false // not needed for react!!
			},
			react: {
				useSuspense: true
			}
		},
		(err, t) => {}
	)

export default i18n
